import React, { Component,PropTypes } from 'react';
import render from "react-dom";
import { Link } from "react-router";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import roleService from 'SERVICES/ella/roleService'
import Tip from 'CONFIG/component/tip'
import ModalDel from 'CONFIG/component/ModalDel'
import BoxHeader from "CONFIG/component/boxHeader"
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import LongSearchInput from 'CONFIG/component/search/longSearchInput'
import {language,pageOption} from 'UTIL/common'
export default class RoleIndex extends Component {
    constructor(props) {
        super(props);
        this.editFormatter = this.editFormatter.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.btnSearch = this.btnSearch.bind(this);
        this.delList = this.delList;
        this.delClick = this.delClick;
        this.state = {
            list: [],
            pageSize: 10,
            current: 1,
            total: 0,
            delRow:{id:"",roleName:""},
        };
    }
    componentDidMount() {
        this.onPageChange(this.state.current,this.state.pageSize);
    }
    onPageChange(page,perpager,e){
        var arr = {
            current:page,
            size:perpager,
            search:$.trim($("#search").val()),
            userId : sessionStorage.userId,
        };
        const data = JSON.stringify(arr);
        roleService.getListRole({data}).then(body=>{
            console.log(body)
            this.setState({
                current:body.data.current,
                pageSize:body.data.size,
                list : body.data.records,
                total : body.data.total,
            })
        })
    }
    btnSearch(){
        this.onPageChange(1,this.state.pageSize);
    }
    editFormatter(cell,row){
        return <span>
        			<Link  to = {"/ella/role/roleEdit/"+row.id} className="btn btn-sm btn-info">
                        {language()['edit']}
		            </Link>&nbsp;&nbsp;
            <a className="btn btn-sm btn-danger" data-target="#tipModal" data-toggle="modal"
               onClick={this.delList.bind(this,row.id,row.roleName)}>{language()['delete']}</a>&nbsp;&nbsp;
        			<Link  to = {"/ella/role/roleDetail/"+row.id} className="btn btn-sm btn-warning">
                        {language()['view']}
		            </Link>
                </span>;
    }
    delList(id,name){
        var delRow = {
            id:id,
            roleName:name,
        };
        this.setState({
            delRow:delRow
        });
    }
    delClick(){
        const id = this.state.delRow.id;
        roleService.roleDel(id).then(body=>{
            this.onPageChange(1,this.state.pageSize);
            if (body.code == 8001) {
                $("#success_msg").text(body.msg);
                $("#success_tip").removeClass("hidden");
                setTimeout(function() {
                    $("#success_tip").addClass("hidden");
                }, 3000);
            } else {
                $("#error_msg").text(body.msg);
                $("#error_tip").removeClass("hidden");
                setTimeout(function() {
                    $("#error_tip").addClass("hidden");
                }, 3000);
            }
        })
    }
    reset(){
        $("#search").val('');
        this.onPageChange(1,10)
    }

    render() {
        let options = pageOption(this.state.current,this.state.pageSize);
        options['onPageChange']=this.onPageChange.bind(this);
        return (
            <div >
                <ContentHeader nameLg={'staffManagement'} nameSm="roleManagement" />
                <section className="content" >
                    <div className="box box-primary color-palette-box">
                        <BoxHeader title={'roleList'} name="add" url="/ella/role/roleAdd"/>
                        <div className="box-body">
                            <Tip ids={""}/>
                            <div className="title-box">
                                <div className="clearfix">
                                    <LongSearchInput id="search" name={language()['roleName']+"/"+language()['roleNo']}/>
                                    <button type="button" className="btn btn-info" onClick={this.btnSearch}>{language()['query']}</button>
                                    &nbsp;&nbsp;<button type="button" className="btn btn-warning" id="reset" onClick={this.reset.bind(this)}>{language()['resetting']}</button>
                                </div>
                            </div>
                            <br/>
                            <BootstrapTable data={this.state.list} height={'auto'} options={options}  remote={true} fetchInfo={{ dataTotalSize: this.state.total }}
                                            striped hover condensed pagination={true} ref='table'>
                                <TableHeaderColumn dataField='id' isKey dataAlign="center" hidden={true}>id</TableHeaderColumn>
                                <TableHeaderColumn dataField='roleName'width="200" >{language()['roleName']}</TableHeaderColumn>
                                <TableHeaderColumn  dataField='roleNumber'width="200">{language()['roleNo']}</TableHeaderColumn>
                                <TableHeaderColumn   dataFormat={this.editFormatter} width="180" columnClassName="td-mid">{language()['operate']}</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </section>
                <ModalDel delModSure={this.delClick.bind(this)} id="tipModal"/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/role/roleIndex.js